import React, { useState, useEffect } from 'react';
import { Button, Modal, ModalHeader, ModalBody, Spinner, Alert, } from 'reactstrap';
import ChargeStatementDocumentForm from '../Forms/ChargeStatementDocumentForm';
// import { deleteResidue } from '../../../../slices/thunks';
// import { setRequireCloseModal } from '../../../../slices/residue/reducer';

const ChargeStatementDocumentModal = ({ data, isOpen, handleToggleModal }) => {
	return (
		<div>
			<Modal
				isOpen={isOpen}
				toggle={() => handleToggleModal()}
				size='lg'
				className='border-0'
				modalClassName='modal fade zoomIn'
				backdrop={'static'}
				centered={true}
			>
				<ModalHeader toggle={handleToggleModal}>Cargar Certificado Declaración de SINADER</ModalHeader>
				{isOpen ? (
					<ChargeStatementDocumentForm
						isOpen={isOpen}
						data={data}
						handleToggleModal={handleToggleModal}
					/>
				) : null}
			</Modal>
		</div>
	);
};

export default ChargeStatementDocumentModal;